import { useState } from 'react'
import { supabase } from '../api/supabase'
import { attributsNouveauMotDePasse, traduireErreurAuth, verifierNouveauMotDePasse } from '../api/motDePasse'
import { Modale } from './Modale'

/**
 * « Changer mon mot de passe » — pour la personne connectée.
 *
 * La console marchand l'a depuis longtemps ; le dispatch n'avait aucun moyen de
 * changer le sien, alors que ses comptes sont créés avec un code temporaire, comme
 * ceux des marchands. Pour un mot de passe OUBLIÉ, c'est le lien reçu par e-mail
 * (écran de connexion), pas cet écran.
 */
export function MotDePasse({
  surFermer,
  invitation = false,
}: {
  surFermer: () => void
  /** Ouvert d'office parce que le compte a un mot de passe temporaire : on peut reporter. */
  invitation?: boolean
}) {
  const [nouveau, setNouveau] = useState('')
  const [confirmation, setConfirmation] = useState('')
  const [message, setMessage] = useState<{ texte: string; erreur: boolean } | null>(null)
  const [envoi, setEnvoi] = useState(false)

  async function enregistrer() {
    const probleme = verifierNouveauMotDePasse(nouveau, confirmation)
    if (probleme) {
      setMessage({ texte: probleme, erreur: true })
      return
    }
    setEnvoi(true)
    const { error } = await supabase.auth.updateUser(attributsNouveauMotDePasse(nouveau))
    setEnvoi(false)
    if (error) {
      setMessage({ texte: traduireErreurAuth(error), erreur: true })
      return
    }
    setMessage({ texte: 'Mot de passe modifié.', erreur: false })
    setNouveau('')
    setConfirmation('')
    setTimeout(surFermer, 1200)
  }

  return (
    <Modale titre="Changer mon mot de passe" ouverte surFermer={surFermer}>
      <p style={{ color: 'var(--n400)', fontSize: 12.5, margin: '0 0 8px' }}>
        {invitation
          ? 'Vous vous êtes connecté(e) avec un mot de passe temporaire, connu de l’équipe qui a créé votre compte. Choisissez dès maintenant un mot de passe que vous êtes seul(e) à connaître.'
          : 'Choisissez un mot de passe que vous êtes seul(e) à connaître. Vous restez connecté(e) sur cet appareil.'}
      </p>
      <label htmlFor="mdp-nouveau">Nouveau mot de passe</label>
      <input
        id="mdp-nouveau"
        type="password"
        autoComplete="new-password"
        placeholder="Au moins 6 caractères"
        value={nouveau}
        onChange={(e) => setNouveau(e.target.value)}
        autoFocus
      />
      <label htmlFor="mdp-confirmation">Confirmer</label>
      <input
        id="mdp-confirmation"
        type="password"
        autoComplete="new-password"
        placeholder="Retapez le mot de passe"
        value={confirmation}
        onChange={(e) => setConfirmation(e.target.value)}
      />
      {message && (
        <p style={{ fontSize: 12.5, margin: '8px 0 0', color: message.erreur ? 'var(--danger)' : 'var(--green)' }}>
          {message.texte}
        </p>
      )}
      <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
        <button className="btn btn-outline" onClick={surFermer}>
          {invitation ? 'Plus tard' : 'Annuler'}
        </button>
        <button className="btn btn-accent" disabled={envoi} onClick={() => void enregistrer()}>
          {envoi ? 'Enregistrement…' : 'Enregistrer'}
        </button>
      </div>
    </Modale>
  )
}
